import { FC } from "react";

import { cn } from "@/lib/utils";

type BannerProps = {
  icon?: React.ReactNode;
  message: string;
  className?: string;
};

export const Banner: FC<BannerProps> = ({ icon, message, className }) => {
  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 gap-2 p-2 text-sm bg-black text-white text-center z-100 flex items-center justify-center",
        className,
      )}
    >
      {icon}
      {message}
    </div>
  );
};
